package components

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import styles.AppStyleSheet

@Composable
fun StatusSelector(
    currentStatus: String,
    onStatusChange: (String) -> Unit,
) {
    Div({ classes(AppStyleSheet.formGroup) }) {
        Label { Text("ステータス") }
        Div({ classes(AppStyleSheet.statusSelector) }) {
            Button({
                classes(
                    if (currentStatus == "published") {
                        AppStyleSheet.statusButtonActive
                    } else {
                        AppStyleSheet.statusButton
                    },
                )
                onClick { onStatusChange("published") }
            }) { Text("公開") }
            Button({
                classes(
                    if (currentStatus == "draft") {
                        AppStyleSheet.statusButtonActive
                    } else {
                        AppStyleSheet.statusButton
                    },
                )
                onClick { onStatusChange("draft") }
            }) { Text("下書き") }
            Button({
                classes(
                    if (currentStatus == "archived") {
                        AppStyleSheet.statusButtonActive
                    } else {
                        AppStyleSheet.statusButton
                    },
                )
                onClick { onStatusChange("archived") }
            }) { Text("アーカイブ") }
        }
    }
}
